import React, { useMemo, useState } from 'react';
import { CatalogGroupList } from '@/seller/components/catalog-groups/CatalogGroupList';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { Trans } from '@lingui/react/macro';
import { CatalogGroupEditDialog } from '../catalog-groups/CatalogGroupEditDialog';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import { CatalogFilterData, CatalogGroup, OptionalId } from '@/types';
import { searchCatalogGroups } from '@/services/profile-catalog-groups';
import { useDefaultScrollToId, useAsyncStateWithIsLoading, useGetActiveProfile } from '@/utils/hooks';
import { CatalogFilter, CatalogFilterValue } from './CatalogFilter';
import { Button, ButtonBar } from '@ygtechnologies/rubus-ui';

interface CatalogGroupsProps {}

export const CatalogGroups: React.FC<CatalogGroupsProps> = ({}) => {
    const profileId = useGetActiveProfile()!.id;

    const [editingGroup, setEditingGroup] = useState<OptionalId<CatalogGroup> | null>(null);
    const defaultExpandedId = useDefaultScrollToId();
    const [filter, setFilter] = useState<CatalogFilterValue>(CatalogFilterValue.empty());
    const [groups, , reloadGroups, isLoading] = useAsyncStateWithIsLoading(
        () =>
            searchCatalogGroups({
                ownerProfileId: profileId,
                itemCategoryIds: filter.itemCategoryIds,
                searchText: filter.searchText,
            }),
        [filter, profileId],
        null
    );

    const filterData = useMemo<CatalogFilterData>(() => {
        return {
            suppliers: [],
        };
    }, [groups]);

    const handleCreateGroupClick = (e) => {
        setEditingGroup({
            ownerProfileId: profileId,
            name: '',
            hasNoneOption: false,
            noneOptionDescription: '',
            noneOptionName: '',
        });
    };

    const handleEditDialogClose = () => {
        setEditingGroup(null);
    };

    const handleEditDialogSave = () => {
        reloadGroups();
    };

    const handleDelete = () => {
        reloadGroups();
    };

    if (!groups) {
        return <LoadingIndicator />;
    }
    return (
        <>
            <ButtonBar>
                <Button variant="tertiary" onClick={handleCreateGroupClick} icon={faPlus}>
                    <Trans>Create new product group</Trans>
                </Button>

                <ButtonBar.Right>
                    <CatalogFilter isLoading={isLoading} filter={filter} onChange={setFilter} data={filterData} />
                </ButtonBar.Right>
            </ButtonBar>

            <CatalogGroupEditDialog
                show={!!editingGroup}
                group={editingGroup}
                onClose={handleEditDialogClose}
                onSave={handleEditDialogSave}
            />

            <CatalogGroupList
                defaultExpandedId={defaultExpandedId}
                groups={groups || []}
                onEditClick={(g) => setEditingGroup(g)}
                onDelete={handleDelete}
            />
        </>
    );
};
